import { render, staticRenderFns } from "./parallexSection.vue?vue&type=template&id=c1562140&"
import script from "./parallexSection.vue?vue&type=script&lang=js&"
export * from "./parallexSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports